<template>
  <a-form-model ref="informationForm" :model="form" :rules="rules">
    <a-row :gutter="12">
      <a-col :span="12">
        <a-form-model-item label="Contract Date" prop="date">
          <a-date-picker
          :format="getDefaultDateFormat"
            v-model="form.date"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="Sales Notification" prop="sales_notification">
          <a-input
            v-if="mode == 'Edit'"
            disabled
            v-model="form.sales_notification"
          ></a-input>
          <a-select
            v-else
            showSearch
            optionFilterProp="children"
            class="select-between"
            placeholder="Please Select"
            @change="fetchProduct()"
            v-model="form.sales_notification"
            :default-value="form.sales_notification"
          >
            <a-select-option
              v-for="item in getMasterSC.sales_notification"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="Code Cost Center" prop="kode">
          <a-select
            showSearch
            class="select-between"
            placeholder="Please Select"
            v-model="form.kode"
            @change="handleChangeCCC"
          >
            <a-select-option v-for="item in getMasterSC.kode" :key="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="contract_no"
          label="Contract No."
          prop="contract_no"
        >
          <a-input
            v-model="form.contract_no"
            @blur="
              () => {
                $refs.contract_no.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="description" label="Contract Name" prop="description">
          <a-input
            v-model="form.description"
            @blur="
              () => {
                $refs.description.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <!-- <a-form-model-item label="Budget Operation Authority" prop="pimpro">
          <a-select
            showSearch
            class="select-between"
            placeholder="Please Select"
            v-model="form.pimpro"
          >
            <a-select-option
              v-for="item in getMasterSC.pimpro"
              :key="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="Contract Periode" prop="periode">
          <a-range-picker
            :format="getDefaultDateFormat"
            v-model="form.periode"
          />
        </a-form-model-item>
        <a-form-model-item label="SKTD PPN No." ref="sktd_ppn_no" prop="sktd_ppn_no">
          <a-input
            v-model="form.sktd_ppn_no"
            @blur="
              () => {
                $refs.sktd_ppn_no.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        
        <a-form-model-item label="Invoice To">
          <a-textarea
            v-model="form.invoice_to"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "sales-contract-information",
  props: {
    dataProcessed: {},
    mode: String,
  },
  data() {
    return {
      form: {
        date: null,
        sales_notification: null,
        kode: null,
        contract_no: null,
        description: null,
        sktd_ppn_no: null,
        // pimpro: null,
        periode: null,
        invoice_to: null,
      },
      rules: {
        date: [{ 
            required: true,
            message: "Please select date",
            trigger: "change", 
        }],
        sales_notification: [
          {
            required: true,
            message: "Please select sales notification",
            trigger: "change",
          },
        ],
        kode: [
          {
            required: true,
            message: "Please select kode",
            trigger: "change",
          },
        ],
        description : [
          {
            required: true,
            message: "Please select Contract name",
            trigger: "change",
          },
        ],
        // pimpro: [
        //   {
        //     required: true,
        //     message: "Please select pimpro",
        //     trigger: "change",
        //   },
        // ],
        periode: [
          {
            required: true
          },
        ],
        contract_no: [
          {
            required: true,
            message: "Please input contract no",
            trigger: "blur",
            format: this.getDefaultDateFormat
          },
          { min: 3, message: "Length should be more than 3 ", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getMasterSC",
    ]),
  },
  watch: {
    dataProcessed() {
      this.initialData();
    },
  },
  mounted() {
    this.initialData();
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        kode: this.dataProcessed.information.kode
          ? this.dataProcessed.information.kode
          : "",
        sales_notification: this.dataProcessed.information.sales_notification
          ? this.dataProcessed.information.sales_notification
          : "",
        contract_no: this.dataProcessed.information.contract_no
          ? this.dataProcessed.information.contract_no
          : "",
        description: this.dataProcessed.information.description
          ? this.dataProcessed.information.description
          : "",
        sktd_ppn_no: this.dataProcessed.information.sktd_ppn_no
          ? this.dataProcessed.information.sktd_ppn_no
          : "",
        // pimpro: this.dataProcessed.information.pimpro
        //   ? this.dataProcessed.information.pimpro
        //   : "",
        invoice_to: this.dataProcessed.information.invoice_to
          ? this.dataProcessed.information.invoice_to
          : "",
        periode: this.dataProcessed.information.periode == undefined ? null: [moment(this.dataProcessed.information.periode[0]),moment(this.dataProcessed.information.periode[1])],
        date: (this.mode == "Create" ? moment() : (this.dataProcessed.information.date != undefined ?  moment(this.dataProcessed.information.date,'YYYY-MM-DD') : null))
      };
    },
    handleRef() {
      this.$refs.informationForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("dataProcessed", this.form);
      });
    },
    fetchProduct() {
      this.$store
        .dispatch("getDetailProduct", {
          auth: this.getAuth,
          params: this.form.sales_notification,
        })
        .then((res) => {
          // console.log(res);
        });
    },
    handleChangeCCC(item){
      let el = _.filter(this.getMasterSC.kode,(e)=>e.value==item)
      this.form.description = el[0].project_name
    }
  },
};
</script>

<style>
</style>